/**
 * SFrame209 — Assess Estate Income Tax (checklist-only).
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-209';

const ITEMS = [
  {
    id: 'i9-1',
    title: 'Check Estate Income Threshold',
    description:
      'Determine if the estate earned more than $600 in income after the date of death (Form 1041 required).',
  },
  {
    id: 'i9-2',
    title: 'Identify Need for Form 1041',
    description: 'Confirm whether a fiduciary income tax return is required and the filing deadline.',
  },
  {
    id: 'i9-3',
    title: 'Apply for Federal EIN',
    description:
      'Obtain a federal Employer Identification Number for the estate (required to open estate accounts and file Form 1041).',
  },
];

export default function SFrame209() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId)
    return <div className="max-w-2xl mx-auto py-12 px-4 text-sm text-stone-600">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="Assess Estate Income Tax"
      backTo={`/sframe-207/${estateId}`}
      backLabel="← Tax Filings"
      items={ITEMS}
      syncTaxDt4Guided
    />
  );
}
